// extracted by mini-css-extract-plugin
module.exports = {"parent":"Loading_parent__OSlri"};